interface Subscription {
    key: string,
    handler: Function,
    assignEmpty: boolean
}
class StorageObservable {
    constructor() {
        window.addEventListener('storage', (e) => this.emitter(e))
    }
    private subscriptions: Subscription[] = []
    /**
     * Подписка на событие storage
     * @param key ключ параметра
     * @param handler обработчик подписки
     * @param assignEmpty разрешает пустым значениям обрабатываться подписками
     */
    subscribe<T>(key: string, handler: (data: T) => void, assignEmpty = false) {
        this.subscriptions.push({
            key,
            handler,
            assignEmpty
        })
    }
    /**
     * Испускание события storage
     * @param key Ключ параметра
     * @param data Сериализуемый объект
     * @param clear Очищать ли item после emit. Default value: true
     */
    emit<T extends any>(key: string, data: T, clear = true) {
        localStorage.setItem(key, JSON.stringify(data))
        if (clear) localStorage.removeItem(key)
    }
    private emitter(e: StorageEvent) {
        this.subscriptions.forEach((s) => {
            if (s.key === e.key && (e.newValue || s.assignEmpty)) s.handler(e.newValue ? JSON.parse(e.newValue) : e.newValue)
        })
    }
}

let storageObservable = new StorageObservable()

export default storageObservable